export default "__VITE_ASSET__054e789c__"